
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Weedingcarrentalinmumbai() {



    const cardData =
    {
        keyword: 'Wedding Car Rental in Mumbai',
        heading: 'S9 Travels: Wedding Car Rental in Mumbai',
        headingDescription: 'S9 Travels offers Wedding Car Rental in Mumbai, providing luxurious, stylish, and well-maintained cars to make your special day truly grand. Choose from a premium fleet, including luxury sedans, SUVs, and classic vintage cars, to match your wedding theme. Enjoy on-time service, professional chauffeurs, affordable pricing, and 24/7 availability for a seamless experience. Book your Wedding Car Rental in Mumbai with S9 Travels and make a grand entrance on your big day!',


        top: 'Top Places to Visit in Mumbai with S9 Travels',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "One of Mumbai's most iconic landmarks, the Gateway of India was built in 1924 to commemorate the visit of King George V and Queen Mary to India. Overlooking the Arabian Sea, this grand arch is a popular tourist attraction and a starting point for boat rides to Elephanta Caves."
    },
    {
      "title": "Marine Drive",
      "description": "A scenic boulevard stretching along the Arabian Sea, Marine Drive is one of the best places to enjoy a peaceful evening in Mumbai. The curved promenade, also known as the 'Queen's Necklace' when lit up at night, is perfect for a leisurely stroll or simply watching the sunset."
    },
    {
      "title": "Elephanta Caves",
      "description": "Located on Elephanta Island, these ancient rock-cut caves date back to the 5th-7th centuries and are dedicated to Lord Shiva. A UNESCO World Heritage Site, the caves feature stunning sculptures, including the famous three-faced statue of Lord Shiva known as Trimurti."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus",
      "description": "A UNESCO World Heritage Site, this historic railway station is a stunning example of Victorian Gothic architecture. Built in 1887, the station is a bustling hub of Mumbai’s railway network and a must-visit for architecture enthusiasts."
    },
    {
      "title": "Siddhivinayak Temple",
      "description": "One of the most revered temples in Mumbai, the Siddhivinayak Temple is dedicated to Lord Ganesha. Devotees from all over the country visit this temple to seek blessings, including celebrities and politicians."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "Situated on a small islet in the Arabian Sea, Haji Ali Dargah is a beautiful Indo-Islamic shrine dedicated to the Sufi saint Pir Haji Ali Shah Bukhari. Connected to the mainland by a narrow causeway, the dargah is a spiritual and architectural marvel."
    },
    {
      "title": "Chowpatty Beach",
      "description": "A popular beach in South Mumbai, Chowpatty Beach is famous for its vibrant street food scene, offering delicacies like pav bhaji, bhel puri, and kulfi. It is also a significant location for Ganesh Chaturthi celebrations."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane bridge that connects South Mumbai with the western suburbs. The cable-stayed bridge offers breathtaking views of the Mumbai skyline, especially at night when it's beautifully illuminated."
    },
    {
      "title": "Colaba Causeway",
      "description": "A bustling shopping street near the Gateway of India, Colaba Causeway is famous for its street markets, fashion boutiques, antique stores, and cafes. It's the perfect place for shopaholics and those looking to experience Mumbai’s lively street culture."
    },
    {
      "title": "Sanjay Gandhi National Park",
      "description": "A green oasis in the heart of Mumbai, Sanjay Gandhi National Park is home to diverse flora and fauna, including leopards and deer. The park also features the ancient Kanheri Caves, a group of rock-cut Buddhist caves dating back to the 1st century BCE."
    }
],

"services": [
  {
    "name": "Wedding Car Rental in Mumbai",
    "description": "S9 Travels offers premium wedding car rental services in Mumbai, ensuring a smooth and elegant travel experience on your special day. Whether you need a classic car or a luxury limousine, our fleet is designed to meet your wedding transportation needs with style and comfort."
  },
  {
    "name": "Book Wedding Cars in Mumbai",
    "description": "Booking wedding cars in Mumbai is easy with S9 Travels. We provide a wide range of vehicles to suit your wedding theme, from luxury sedans to vintage cars. Our professional chauffeurs ensure timely and safe arrivals, letting you focus on enjoying your big day."
  },
  {
    "name": "Affordable Wedding Car Rental in Mumbai",
    "description": "S9 Travels offers affordable wedding car rental services in Mumbai, providing cost-effective options without compromising on style or comfort. Whether you're on a budget or looking for a premium experience, we have the perfect car for your wedding at competitive rates."
  },
  {
    "name": "Luxury Wedding Cars for Hire in Mumbai",
    "description": "Travel in opulence with luxury wedding cars for hire in Mumbai from S9 Travels. Choose from our premium fleet, including limousines, high-end sedans, and vintage cars, to add a touch of elegance and sophistication to your wedding day. Enjoy a comfortable and stylish ride to your venue."
  },
  {
    "name": "Mumbai Wedding Car Hire for Special Occasions",
    "description": "Make your wedding day unforgettable with Mumbai wedding car hire from S9 Travels. We offer a variety of elegant vehicles for the bride, groom, and guests. From vintage cars to modern luxury options, our cars ensure a memorable and stylish experience for your special day."
  },
  {
    "name": "Wedding Transportation in Mumbai",
    "description": "S9 Travels provides seamless wedding transportation in Mumbai, offering a range of vehicles for the bride, groom, and guests. Whether you need a single vehicle or multiple cars, we ensure that everyone travels in comfort and arrives at the venue on time, making your wedding day stress-free."
  },
  {
    "name": "Bridal Car Hire in Mumbai",
    "description": "For the bride who deserves the best, S9 Travels offers exclusive bridal car hire in Mumbai. Our luxury vehicles, including elegant sedans and vintage cars, ensure you arrive at your wedding venue in style. Enjoy the comfort and luxury of a premium bridal ride to make your big day even more special."
  },
  {
    "name": "Wedding Convoy Service in Mumbai",
    "description": "S9 Travels provides wedding convoy services in Mumbai, offering coordinated transport for all your wedding guests. Whether you're organizing transportation for family members or a large group, our convoy service ensures smooth and timely arrivals, with a fleet of cars and professional drivers."
  },
  {
    "name": "Mumbai Wedding Limousine Service",
    "description": "Arrive in style with our Mumbai wedding limousine service. S9 Travels offers luxurious limousines for your wedding day, complete with premium amenities and a professional chauffeur. Perfect for the bride, groom, or VIP guests, our limousines add an element of luxury to your wedding celebration."
  }
],

"tableData": [
  ["Wedding Car Rental in Mumbai", "Book Wedding Cars in Mumbai"],
  ["Affordable Wedding Car Rental in Mumbai", "Luxury Wedding Cars for Hire in Mumbai"],
  ["Mumbai Wedding Car Hire for Special Occasions", "Wedding Transportation in Mumbai"],
  ["Bridal Car Hire in Mumbai", "Wedding Convoy Service in Mumbai"],
  ["Mumbai Wedding Limousine Service", ""],
  ["", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Elegant and Luxurious Wedding Cars",
    "WhyChoosedescription": "S9 Travels offers a premium selection of luxury wedding cars for rent in Mumbai, including high-end vehicles such as Mercedes, BMW, Audi, and the Toyota Innova. Our fleet ensures you travel in style and elegance, making your wedding day truly special."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand the importance of being punctual on your wedding day. Our wedding car rental service in Mumbai ensures timely pick-ups and drop-offs, so you can relax and enjoy the occasion while we take care of your transportation needs."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our professional and experienced drivers are dedicated to providing you with a smooth and comfortable ride. Dressed in formal attire and knowledgeable about the best routes, they ensure that your wedding day transportation is both efficient and stress-free."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for wedding car rentals in Mumbai, with no hidden charges. We provide a clear and transparent pricing structure, allowing you to plan your wedding transportation budget with confidence."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Wedding Day",
    "WhyChoosedescription": "Your safety and comfort are our top priorities. Our wedding cars come equipped with modern safety features such as airbags, GPS tracking, and seat belts, ensuring that you have a safe and luxurious ride throughout your special day."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your wedding car rental needs in Mumbai. Whether you need a car for early morning ceremonies or late-night receptions, we are here to ensure your wedding transportation is on time."
  },
  {
    "WhyChooseheading": "Customizable Wedding Car Packages",
    "WhyChoosedescription": "Every wedding is unique, and we offer customizable wedding car packages to suit your specific needs. Whether you require multiple vehicles for your bridal party or have special requests, we can tailor our services to make your wedding day transportation unforgettable."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your wedding car rental with S9 Travels is easy and hassle-free. You can book your vehicle online through our website or mobile app, or reach out to our customer service team for personalized assistance to ensure a smooth and seamless booking process."
  }
]
















    }

    const faqData = [
        [
          {
            question: 'How can I book a wedding car rental in Mumbai?',
            answer: 'Booking a wedding car rental in Mumbai is simple! You can make a reservation through our website, mobile app, or by contacting our customer service team for personalized assistance. We ensure that your special day is as smooth as possible.',
          },
          {
            question: 'What types of wedding cars are available for rent in Mumbai?',
            answer: 'We offer a wide selection of wedding cars for rent in Mumbai, including luxury sedans, SUVs, vintage cars, and classic cars. Choose the vehicle that best matches your wedding theme and adds elegance to your celebration.',
          },
          {
            question: 'Do you provide chauffeurs with the wedding car rental in Mumbai?',
            answer: 'Yes, we provide experienced and professional chauffeurs with all our wedding car rentals in Mumbai. Our chauffeurs are well-dressed, polite, and will ensure a smooth and memorable journey for you on your wedding day.',
          },
          {
            question: 'How early should I book my wedding car in Mumbai?',
            answer: 'We recommend booking your wedding car at least 2-3 weeks in advance to secure the vehicle of your choice. However, we may also accommodate last-minute bookings based on availability.',
          },
          {
            question: 'Can I decorate the wedding car for my ceremony?',
            answer: 'Yes, you can decorate the wedding car with flowers, ribbons, and other decorative elements to match your wedding theme. We can also help you with recommendations and arrangements for decorations if needed.',
          },
          {
            question: 'What is the rental duration for a wedding car in Mumbai?',
            answer: 'Wedding car rentals in Mumbai are available on an hourly or full-day basis. We can customize the rental duration based on your wedding events, whether it’s for the ceremony, reception, or a whole day’s celebration.',
          },
          {
            question: 'How much does it cost to rent a wedding car in Mumbai?',
            answer: 'The cost of renting a wedding car in Mumbai depends on the type of vehicle, duration of the rental, and any additional services. Contact us for a customized quote based on your wedding requirements and preferences.',
          },
          {
            question: 'Can I rent multiple wedding cars for my wedding in Mumbai?',
            answer: 'Yes, we can provide multiple wedding cars for large weddings. Whether you need separate cars for the bride, groom, and family, we can arrange a fleet of vehicles to accommodate your guests and ensure everyone arrives on time.',
          },
          {
            question: 'Can I request a specific car model for my wedding rental in Mumbai?',
            answer: 'Yes, we offer a range of luxury and classic cars, and you can request a specific model for your wedding. Booking in advance will help you secure the vehicle that best fits your style and preferences.',
          },
          {
            question: 'Why should I choose S9 Travels for my wedding car rental in Mumbai?',
            answer: 'S9 Travels offers an exceptional selection of luxury, vintage, and classic cars for weddings in Mumbai. Our professional chauffeurs, attention to detail, and commitment to providing a seamless experience ensure that your special day will be memorable and stress-free.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Groom',
          rating: [1, 1, 1, 1, 1],
          text: '“I rented a wedding car from S9 Travels for my wedding in Mumbai, and it was an unforgettable experience. The car was beautiful, and the chauffeur was incredibly professional. It made our day even more special and added a luxurious touch to our wedding. Highly recommend their services!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Bride',
          rating: [1, 1, 1, 1, 1],
          text: '“Our wedding car rental from S9 Travels in Mumbai was fantastic! The car was exactly what we envisioned, and the driver was punctual and very courteous. It truly enhanced the whole wedding experience. I would definitely recommend S9 Travels for anyone looking for a wedding car rental in Mumbai!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Wedding Car Rental in Mumbai",
        "description": "Book luxury and affordable wedding car rental services in Mumbai. Whether you're looking for a bridal car, wedding convoy, or limousine service, S9 Travels offers a wide selection of cars for your special day, ensuring comfort and style.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
    
      
      
      


    return (
        <div>
          <Helmet>
        <title>Wedding Car Rental in Mumbai | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book wedding car rentals in Mumbai for your special day. Luxury bridal cars, wedding convoy, and limousine services. Affordable and stylish wedding transportation with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/77.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Weedingcarrentalinmumbai;